"use client";

import React from 'react';
import { registerComponent } from '../../lib/vulcan-lib/components';
import withErrorBoundary from '../common/withErrorBoundary';
import { AnalyticsContext } from '../../lib/analyticsEvents';
import { useCurrentUser } from '../common/withUser';
import { useQuery } from "@/lib/crud/useQuery";
import { gql } from "@/lib/generated/gql-codegen";
import PostsItem from "../posts/PostsItem";
import LWTooltip from "../common/LWTooltip";
import SingleColumnSection from "../common/SingleColumnSection";
import SectionTitle from "../common/SectionTitle";
import SectionFooter from "../common/SectionFooter";
import LoadMore from "../common/LoadMore";
import { useQueryWithLoadMore } from '../hooks/useQueryWithLoadMore';
import { useDialog } from '../common/withDialog';
import SectionButton from '../common/SectionButton';
import NewDialogueDialog from '../posts/NewDialogueDialog';
import LoginPopup from '../users/LoginPopup';

const PostsListWithVotesQuery = gql(`
  query DialoguesPage($documentId: String) {
    post(input: { selector: { documentId: $documentId } }) {
      result {
        ...PostsListWithVotes
      }
    }
  }
`);

const DialoguesPage = () => {
  const initialLimit = 20;

  const { data: recentlyActiveDialoguesData, loadMoreProps: dialoguePostsLoadMoreProps } = useQueryWithLoadMore(gql(`
    query RecentlyActiveDialogues($limit: Int) {
      RecentlyActiveDialogues(limit: $limit) {
        results {
          ...PostsListWithVotes
        }
      }
    }
  `), {
    variables: { limit: initialLimit },
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
  });

  const dialoguePosts = recentlyActiveDialoguesData?.RecentlyActiveDialogues?.results;
  
  const { data: myDialoguesData, loadMoreProps: myDialoguesLoadMoreProps } = useQueryWithLoadMore(gql(`
    query MyDialogues($limit: Int) {
      MyDialogues(limit: $limit) {
        results {
          ...PostsListWithVotes
        }
      }
    }
  `), {
    variables: { limit: 10 },
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
  });

  const myDialogues = myDialoguesData?.MyDialogues?.results;

  const currentUser = useCurrentUser();
  const { openDialog } = useDialog();

  const renderMyDialogues = currentUser && myDialogues?.length

  const handleNewDialogueClick = () => {
    if (!currentUser) {
      openDialog({name: "LoginPopup",
        contents: ({onClose}) => <LoginPopup onClose={onClose}/>
      });
      return;
    }
    openDialog({
      name: "NewDialogueDialog",
      contents: ({onClose}) => <NewDialogueDialog onClose={onClose}/>
    });
  }

  const { data } = useQuery(PostsListWithVotesQuery, {
    variables: { documentId: "kQuSZG8ibfW6fJYmo" },
  });
  const announcementPost = data?.post?.result;

  const dialoguesTooltip = <div>
    <p>Dialogues between a small group of users.</p>
  </div>

  const myDialoguesTooltip = <div>
    <p>These are the dialoges you are involved in (both drafts and published)</p>
  </div>

  return <AnalyticsContext pageContext="DialoguesPage">
    <SingleColumnSection>
      {renderMyDialogues && <AnalyticsContext pageSectionContext="MyDialoguesList">
          <SectionTitle
              title={<LWTooltip placement="top-start" title={myDialoguesTooltip}>
                My Dialogues (Drafts & Published)
              </LWTooltip>}
            >
              <SectionButton onClick={handleNewDialogueClick}>
                New Dialogue
              </SectionButton>
            </SectionTitle>
          {myDialogues?.map((post: PostsListWithVotes, i: number) =>
            <PostsItem
              key={post._id} post={post}
              showBottomBorder={i < myDialogues.length-1}
            />
          )}
          <SectionFooter>
            <LoadMore {...myDialoguesLoadMoreProps}/>
          </SectionFooter>
        </AnalyticsContext>}

      <AnalyticsContext pageSectionContext="DialoguesList">
        <SectionTitle
          title={<LWTooltip placement="top-start" title={dialoguesTooltip}>
            Dialogues
          </LWTooltip>}
        >
          {!renderMyDialogues && <SectionButton onClick={handleNewDialogueClick}>
            New Dialogue
          </SectionButton>}
        </SectionTitle>
        {announcementPost && <PostsItem
          key={"kQuSZG8ibfW6fJYmo"} post={announcementPost} forceSticky
        />}
        {dialoguePosts?.map((post: PostsListWithVotes, i: number) =>
          <PostsItem
            key={post._id} post={post}
            showBottomBorder={i < dialoguePosts.length-1}
          />
        )}
        <SectionFooter>
          <LoadMore {...dialoguePostsLoadMoreProps}/>
        </SectionFooter>
      </AnalyticsContext>
   </SingleColumnSection>
  </AnalyticsContext>
}

export default registerComponent('DialoguesPage', DialoguesPage, {
  hocs: [withErrorBoundary]
});
